import React,{useEffect} from 'react'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { VariableEvaluation } from './VariableEvaluation';
import { loadProjectTypes } from '../../store/Actions/ActionProjectType';
import { filterEvaluationType } from '../../store/Actions/ActionEvaluationType';
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom';

function FilterEvaluationType({ translate }) {
    const { dispatch, navigate,langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableEvaluation();

    const { projectTypes } = useSelectorCustom()

    useEffect(() => {
        dispatch(loadProjectTypes())
    }, []);
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterEvaluationType(state.name, state.creative_work_type_id, setLoad))
    }
    return (
        <div className='filteruser shadow_main margin_main' dir={langLocal=== 'ar' ? "rtl" : "ltr"}>
            <h3>{translate('search_filter')}</h3>
            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('name')} onChange={(e) => setStateCustom('name', e.target.value)} />
                <select className={`select_filter  ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} onChange={(e) => setStateCustom('creative_work_type_id', e.target.value)} >
                    <option disabled selected >{translate('choose')}</option>
                    {
                        projectTypes.map((item)=>{
                            return(
                                <option value={item.id} >{item.name}</option>
                            )
                        })
                    }
                </select>
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterEvaluationType